import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
const programs = [{
  title: 'Kids Taekwondo',
  description: 'Our kids Taekwondo classes focus on building confidence, listening skills, coordination, and discipline in a fun and structured environment. Students learn respect, self-control, and the importance of setting and achieving goals.',
  image: 'https://cdn.magicpatterns.com/uploads/uUmM1JsiD6jE2GaAFmzVjy/KidsTaekwondo.jpg'
}, {
  title: 'Teen & Adult Taekwondo',
  description: 'Teen and adult Taekwondo classes improve fitness, flexibility, and self-defense while reducing stress and building mental toughness. Whether you are new to martial arts or returning, our classes adapt to all experience levels.',
  image: 'https://cdn.magicpatterns.com/uploads/pVDDAqCP3mbZNaZQp3bcux/Teen-Adult-Taekwondo.jpg'
}, {
  title: 'Competition / Team Training',
  description: 'Our competition program is designed for students interested in Olympic-style sparring and higher-level training. This program emphasizes athletic performance, strategy, and discipline for students who want to push themselves further.',
  image: 'https://cdn.magicpatterns.com/uploads/xBssxPwK6AK6BhEfULDYLu/taekwondo-handshake.jpg'
}];
export function Programs() {
  return <section id="programs" className="py-24 bg-neutral-50" data-id="element-128">
      <div className="container mx-auto px-4" data-id="element-129">
        <div className="text-center mb-16" data-id="element-130">
          <h2 className="text-3xl md:text-5xl font-bold text-neutral-900 mb-4" data-id="element-131">
            Programs for{' '}
            <span className="relative inline-block pb-2" data-id="element-132">
              Every
              <span className="absolute bottom-0 left-0 w-full h-1 bg-red-700 rounded-full" data-id="element-133"></span>
            </span>{' '}
            Age and Skill Level
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-134">
          {programs.map((program, index) => <motion.div key={program.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow flex flex-col h-full" data-id="element-135">
              <div className="h-56 overflow-hidden" data-id="element-136">
                <img src={program.image} alt={program.title} className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500" data-id="element-137" />
              </div>
              <div className="p-8 flex flex-col flex-grow" data-id="element-138">
                <h3 className="text-2xl font-bold text-neutral-900 mb-4" data-id="element-139">
                  {program.title}
                </h3>
                <p className="text-neutral-600 mb-8 flex-grow leading-relaxed" data-id="element-140">
                  {program.description}
                </p>
                <Button fullWidth variant="secondary" href="/signup" data-id="element-141">
                  {program.title === 'Kids Taekwondo' && 'View Class Options'}
                  {program.title === 'Teen & Adult Taekwondo' && 'Choose This Program'}
                  {program.title === 'Competition / Team Training' && 'Learn About Classes'}
                </Button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}